import classnames from "classnames";
import React from "react";
import { Page } from "src/components";
import theme from "src/theme";
import { Mapping } from "src/types/primitives";
import styled from "styled-components";

import {
  AddToCart,
  Banners,
  Collapse,
  Countdown,
  EmbedVideo,
  FocusProducts,
  Header,
  Html,
  Modal,
  SliderImages,
  SliderProducts,
  SliderT2s,
  StoreLocator,
  Text,
} from "./slices";
import { IPrismicPage } from "./types";

interface IContent {
  backgroundColor: string;
  textColor: string;
  fontSize: string;
  cssCustom?: string;
}

const Content = styled.div<IContent>`
  background-color: ${({ backgroundColor }): string => backgroundColor};
  color: ${({ textColor }): string => textColor};
  font-size: ${({ fontSize }): string => fontSize};

  h1 {
    font-family: ${theme.fonts.granville};
    font-size: 32px;
  }

  /**
    Add CSS custom from CMS

    Apply itself only from Content className (generated by styled-components),
    This CSS is nested to this Content className,
    and don't interfere with other styles external to this component.
  */
  ${({ cssCustom }): string | undefined => cssCustom}
`;

export const PageCmsCustom = ({
  cmsId,
  cmsType,
  data,
}: IPrismicPage): JSX.Element | null => {
  if (!data) {
    return <div>No data</div>;
  }

  const {
    v2_body,
    v2_page_name,
    v2_page_class_name,
    v2_page_background_color = "inherit",
    v2_page_text_color = "inherit",
    v2_page_font_size = "15px",
    v2_page_css_custom,
  } = data;

  // const pageData = {
  //   cmsId,
  //   cmsType,
  //   name: page_name?.[0].text,
  //   className: page_class_name,
  //   backgroundColor: page_background_color,
  //   textColor: page_text_color,
  //   fontSize: page_font_size,
  //   cssCustom: page_css_custom?.[0].text,
  // };

  // useEffect(() => {
  //   console.log("PageData: ", pageData);
  // }, [pageData]);

  return (
    <Page tabTitle={v2_page_name?.[0]?.text} childrenInFullWidth noPadding>
      <Content
        className={classnames("cms-content", cmsId, v2_page_class_name)}
        backgroundColor={v2_page_background_color}
        textColor={v2_page_text_color}
        fontSize={v2_page_font_size}
        cssCustom={v2_page_css_custom?.[0]?.text || ""}
      >
        {v2_body?.map(({ slice_type, items, primary }, i: number) => {
          const Component = component[slice_type] ?? component.default;

          return (
            <Component
              slice_type={slice_type}
              primary={primary}
              items={items}
              key={i}
            />
          );
        })}
      </Content>
    </Page>
  );
};

/**
 * Mapping slice_type value => corresponding slice component
 */
const component: Mapping = {
  header: Header,
  text: Text,
  banners: Banners,
  focus_products: FocusProducts,
  html: Html,
  slider_products: SliderProducts,
  slider_images: SliderImages,
  slider_t2s: SliderT2s,
  store_locator: StoreLocator,
  embed_video: EmbedVideo,
  modal: Modal,
  collapse: Collapse,
  countdown: Countdown,
  add_to_cart: AddToCart,
  default: ({ slice_type }): JSX.Element => (
    <div>Component error: {slice_type}</div>
  ),
};
